function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8c3.7 0 6.8-2.6 8-6h-2c-1.2 2.3-3.4 4-6 4-3.3 0-6-2.7-6-6s2.7-6 6-6c1.7 0 3.1.7 4 2L9 7h7V0l-2 2c-1.8-1-3.8-2-6-2z" /></svg>;
});